export const columns = {
  name: 'Фамилия и Имя',
  email: 'Электронная почта',

};

export const columnsKey = 'ExcelColumnsShort';
export const panelTitle = 'Настройка колонок';
